export const socialLinks = [
  {
    icon: "bi-linkedin",
    url: "https://www.linkedin.com/in/mziliNassim/",
    name: "LinkedIn",
    color: "#0A66C2", // Keeps original LinkedIn blue
  },
  {
    icon: "bi-github",
    url: "https://github.com/mziliNassim",
    name: "GitHub",
    color: "#ccc", // GitHub dark gray
  },
  {
    icon: "bi-instagram",
    url: "https://instagram.com/nassim__dev/",
    name: "Instagram",
    color: "#E1306C", // Instagram pink
  },
  {
    icon: "bi-twitter",
    url: "https://twitter.com/nassim__dev/",
    name: "Twitter (X)",
    color: "#1DA1F2", // Twitter blue
  },
  {
    icon: "bi-facebook",
    url: "https://facebook.com/mzilinassim/",
    name: "Facebook",
    color: "#1877F2", // Facebook blue
  },
  {
    icon: "bi-envelope-fill", // Updated icon for email
    url: "mailto:mzilinassim@gmail.com", // Added mailto: for email links
    name: "Email",
    color: "#EA4335", // Gmail red
  },
];
